import { createApp } from "vue";
import VueCookies from "vue3-cookies";
import App from "./App.vue";
import router from "./multipages";
import store from "./stores";
import vuetify from "@/plugins/vuetify";
import snotify from "vue3-snotify";
import VueCropper from "vue-cropper";

import "vuetify/lib/styles/settings/_variables.scss";

import "vuetify/dist/vuetify.min.css";
import "vue3-snotify/style";

import { fpjsPlugin, FingerprintJSPro } from "@fingerprintjs/fingerprintjs-pro-vue-v3";
const fingerprintAPIKey = import.meta.env.VITE_FINGERPRINT_API_KEY;

import { FabricCanvas } from "@/components/FabricWrapper/components";

// Before user leaves (closing tab or window), stop the session
if (!window) throw new Error('window is not defined');

// When app starts, initialize session tracking
store.dispatch("sessionTimer/initSession");

// FingerprintJS Pro loads its agent script eagerly on plugin install, before
// any component attaches a handler to the load promise. If the script fails
// to load (ad blockers, network, CSP), the browser reports it as an unhandled
// rejection here rather than at any of our own getVisitorData() call sites.
window.addEventListener("unhandledrejection", (event) => {
  if (
    event.reason instanceof Error &&
    event.reason.message === "Failed to load the JS script of the agent"
  ) {
    console.error("FingerprintJS Pro Error:", event.reason);
    event.preventDefault();
  }
});

const app = createApp(App);
app.use(fpjsPlugin, {
  loadOptions: {
    apiKey: fingerprintAPIKey,
    // Load the agent from Crane's own proxied domain first (same first-party
    // setup already used in storefront-vue) so ad blockers/privacy extensions
    // that target FingerprintJS's shared CDN (fpnpmcdn.net) don't block it.
    // Falls back to the default CDN if the proxy is unreachable.
    endpoint: ["https://a.crane.com", FingerprintJSPro.defaultEndpoint],
    scriptUrlPattern: [
      "https://a.crane.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",
      FingerprintJSPro.defaultScriptUrlPattern,
    ],
  },
});

app.use(vuetify);
app.use(VueCookies);
app.use(snotify);
app.use(VueCropper);

app.use(store);
app.use(router);
router.afterEach((to, from) => {
  if (window.Appcues && typeof window.Appcues.page === "function") {
    window.Appcues.page();
    console.log("Appcues is loaded.");
  } else {
    console.log("Appcues is not loaded yet.");
  }
});
app.component("FabricCanvas", FabricCanvas);
app.mount("#app");
